import React from "react";
import { motion } from "framer-motion";

const InternshipSection = () => {
  const experiences = [
    {
      id: 1,
      role: "Intern Technologist",
      company: "TruliaCare India Pvt. Ltd.",
      duration: "Dec 2025 – Present",
      isCurrent: true,
      responsibilities:
        "Working on a hospice domain project using C#, .NET Core, and ASP.NET Web API within a microservices-based clean architecture. Developed a CSV synchronization microservice with Redis Lock and Background Services for reliable data processing, and optimized workforce data retrieval using Redis caching and SQL indexing.",
    },
    {
      id: 2,
      role: "MERN Stack Intern",
      company: "IDEVIFY Solutions Pvt. Ltd.",
      duration: "Jan 2025 – May 2025",
      isCurrent: false,
      responsibilities:
        "Collaborated on 3+ full-stack projects using React, Tailwind CSS, and Node.js. Built responsive and user-friendly interfaces while optimizing frontend performance by 25% across multiple devices.",
    },
    {
      id: 3,
      role: "AI Project Intern",
      company: "JSW Steel Coated Products Ltd.",
      duration: "June 2025 – Nov 2025",
      isCurrent: false,
      responsibilities:
        "Developed a real-time AI-based surveillance system using YOLOv8, achieving 60% PPE detection accuracy with Roboflow datasets. Automated PPE compliance monitoring with integrated SMTP email alerts, significantly reducing manual monitoring efforts.",
    },
  ];

  return (
    <section
      id="internship"
      className="section-padding bg-white dark:bg-gray-800 transition-colors duration-300"
    >
      <div className="container-custom">
        {/* Section Heading */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-2 text-gray-900 dark:text-gray-100">
            <span className="text-teal-700 dark:text-accent">02.</span> Internships
          </h2>
          <div className="w-32 h-0.5 bg-teal-700 dark:bg-accent mb-8"></div>
        </motion.div>

        <div className="relative max-w-4xl mx-auto">
          {/* Timeline Line */}
          <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-teal-700 dark:bg-accent"></div>

          <div className="space-y-12">
            {experiences.map((exp, index) => (
              <motion.div
                key={exp.id}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.2 }}
                className="relative pl-20"
              >
                {/* Timeline Marker */}
                <div className="absolute left-0 top-0">
                  <div
                    className={`w-12 h-12 rounded-full flex items-center justify-center ${
                      exp.isCurrent
                        ? "border-4 border-teal-700 dark:border-accent bg-teal-700 dark:bg-accent"
                        : "bg-teal-600 dark:bg-accent"
                    }`}
                  >
                    {exp.isCurrent && (
                      <div className="w-4 h-4 rounded-full bg-white dark:bg-gray-800"></div>
                    )}
                  </div>
                </div>

                {/* Content */}
                <div className="space-y-2 text-sm">
                  <p className="text-gray-800 dark:text-gray-300">
                    <span className="text-teal-700 dark:text-accent font-semibold">
                      {exp.role}
                    </span>{" "}
                    at{" "}
                    <span className="text-teal-700 dark:text-accent font-semibold">
                      {exp.company}
                    </span>
                  </p>

                  <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                    {exp.responsibilities}
                  </p>

                  <p className="text-gray-500 text-xs mt-2">
                    {exp.duration}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InternshipSection;
